import ChevronDown from "@/assets/ChevronDown.svg";
import PropTypes from "prop-types";
import { Dropdown, Nav } from "react-bootstrap";
import { getHeaderMenu } from "@/functions/getHeaderMenu";
import { useState, useEffect } from "react";
import classes from "../../styles.module.scss";

export default function SiteHeaderNav({ className }) {
  const nav = getHeaderMenu();
  const [show, setShow] = useState(null);
  const [country, setCountry] = useState("AU");

  const localeID = "medacs-apac-country-code";

  useEffect(() => {
    if (localStorage.getItem(localeID)) {
      setCountry(localStorage.getItem(localeID));
      return;
    }
    fetch("https://api.ipbase.com/v1/json/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "default",
    })
      .then((res) => res.json())
      .then((data) => {
        localStorage.setItem(localeID, data.country_code);
        setCountry(data.country_code);
      })
      .catch((error) => console.log(error));
  }, []);

  const referAFriendGeoTaggedLink = "/candidate-support/refer-a-friend";

  return (
    <Nav className={className}>
      {nav.map(({ title, children, url, target }, k) =>
        children && children.length ? (
          <Dropdown
            key={k}
            align={nav.length - 1 === k ? "end" : "start"}
            onMouseEnter={() => setShow(k)}
            onMouseLeave={() => setShow(null)}
          >
            <Nav.Item>
              <Nav.Link href={url} target={target}>
                {title}
              </Nav.Link>
              <Dropdown.Toggle variant={false}>
                <ChevronDown onClick={() => setShow(k)} />
              </Dropdown.Toggle>
            </Nav.Item>
            <Dropdown.Menu show={show === k}>
              {children.map(({ title, url, target }, k) => (
                <Dropdown.Item as={Nav.Item} key={k} className="hover-bg-secondary">
                  <Nav.Link
                    href={
                      url === referAFriendGeoTaggedLink ? url + (country === "NZ" ? "-newzealand" : "-australia") : url
                    }
                    target={target}
                  >
                    {title}
                  </Nav.Link>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Nav.Item key={k} className={classes.navItem}>
            <Nav.Link href={url} target={target} className={classes.navLink}>
              {title}
            </Nav.Link>
          </Nav.Item>
        ),
      )}
    </Nav>
  );
}

SiteHeaderNav.defaultProps = {
  className: "",
};

SiteHeaderNav.propTypes = {
  className: PropTypes.string,
};
